import axios from 'axios'

export const NetsisApi = {
    async CariList(data){
        const response = await axios.get(`/api/netsis/get/carilist/${data}`)
        return response
    },
    async CariListAll(data){
        const response = await axios.get(`/api/netsis/get/carilist/all/${data}`)
        return response
    },
    async Table(data){
        const response = await axios.post(`/api/netsis/get/caritable`,data)
        return response
    },
    async GetCariTypesByCari(data){
        const response = await axios.get(`/api/netsis/get/caritypesbycari/${data}`)
        return response
    },
    async UpdateCariTypes(data){
        const response = await axios.post(`/api/netsis/update/caritypes`,data)
        return response
    },
    async GetSeferList(data){
        const response = await axios.post(`/api/netsis/get/list/sefer`,data)
        return response
    },
    // "Bekleyen Referans Grupları" — cari zorunlu değil. Hafta × nakliyeci × şube kırılımında,
    // hâlâ referans grubuna alınmamış seferlerin özeti. Kullanıcı satıra tıklayınca Sefer
    // ekranı ilgili cari/şube/tarih ile otomatik dolar (bkz. VoyageView query-param desteği).
    async GetPendingReferenceGroups(data){
        const response = await axios.post(`/api/netsis/get/list/pending-reference-groups`,data)
        return response
    },
    // Netsis bağlantı sağlık göstergesi. Sunucu cevabı 30 sn cache'li; refresh=true elle
    // yenileme için (LED'e tıklandığında çağrılır).
    async GetNetsisHealth(refresh = false){
        const response = await axios.get(`/api/netsis/health${refresh ? '?refresh=true' : ''}`)
        return response
    },
    async GetSeferListReport(data){
        const response = await axios.post(`/api/netsis/get/list/sefer/report`,data)
        return response
    },
    async GetSeferMaliyetRaporu(data){
        const response = await axios.post(`/api/netsis/get/sefer/maliyet/raporu`,data)
        return response
    },
    async GetSeferListTodayReport(data){
        const response = await axios.post(`/api/netsis/get/list/sefer/report/today`,data)
        return response
    },
    async GetSeferListReportTodayExcel(){
        const response = await axios.get(`/api/netsis/get/list/sefer/report/today/excel`,{
            responseType: 'blob',
        })
        return response
    },
    async GetSeferListReportExcel(data){
        const response = await axios.post(`/api/netsis/get/list/sefer/report/excel`,data,{
            responseType: 'blob',
        })
        return response
    },
    async GetSeferListAllExcel(data){
        const response = await axios.post(`/api/netsis/get/list/sefer/report/excel/all`,data,{
            responseType: 'blob',
        })
        return response
    },
    async StokList(data){
        const response = await axios.get(`/api/netsis/get/list/stok/${data}`)
        return response
    },
    async CreateOrUpdateParameter(update,data){
        const response = await axios.post(update ? `/api/netsis/update/cariparameter`: `/api/netsis/create/cariparameter`,data)
        return response
    },
    async GetSubeList(){
        const response = await axios.get('/api/netsis/get/list/sube')
        return response
    },
    async GetAlisIrsaliye(data){
        const response = await axios.post('/api/netsis/get/alisirsaliye',data)
        return response
    },
    async UpdateAlisIrsaliyeEkAlans(data){
        const response = await axios.post('/api/netsis/update/alisirsaliye/ekalans',data)
        return response
    },
}